import { LANGUAGE_KEYS } from "@internationalization/index";
import { LinkName, links } from "@pages/ClientDetailsSubPages/IntakeForm/Links/config";
import { routeLabelMappings } from "@pages/ClientDetailsSubPages/IntakeForm/Links/routeLabelMappings";

export const getPageTitleFromName = (name: LinkName, language: LANGUAGE_KEYS) => {
  return routeLabelMappings[name][language];
};

export const getCurrentPageTitle = (path: string) => {
  const [routePrimary, routeSecondary] = path.split("/");
  const currentLinkObject = links.find((l) => l.name === routePrimary);

  if (currentLinkObject?.sublinks) {
    const currentSublinkObject = currentLinkObject.sublinks.find((sl) => sl.name === routeSecondary);

    if (currentSublinkObject) {
      return routeLabelMappings[currentSublinkObject.name]["en"];
    }
  }
  if (currentLinkObject) {
    return routeLabelMappings[currentLinkObject.name]["en"];
  }
  throw new Error("Could not find a route link");
};
